<template>
  <el-dialog title="关联文件" :visible="visible" :modal="false" :close-on-click-modal="false" append-to-body @close="$emit('update:visible', false)">
    <div v-if="!typeSelectorHidden" class="mb10">
      <div class="el-alert el-alert--success mb5">
        1、请选择“{{ linkTarget.originalname || linkTarget.filename }}”的文件类型
      </div>
      <el-select v-model="fileType" class="mr10" filterable size="mini" placeholder="文件类型">
        <el-option v-for="val in fileTypes[searchType]" :key="val" :label="val" :value="val"></el-option>
      </el-select>
    </div>
    <div>
      <div class="el-alert el-alert--success mb5">
        {{ typeSelectorHidden ? 1 : 2 }}、搜索、选择关联的人选、公司或项目，关联后文件可在关联对象的附件中查看
      </div>
      <el-input
        v-model="keywords"
        class="mb10"
        placeholder="输入关键字，按回车搜索"
        size="mini"
        clearable
        @keypress.enter.native="handleSearch"
      >
        <el-select slot="prepend" v-model="searchType" filterable class="drawer-select" size="mini">
          <el-option label="人选" value="Radishes"></el-option>
          <el-option label="公司" value="Companies"></el-option>
          <el-option label="项目" value="Projects"></el-option>
        </el-select>
        <el-button slot="append" type="primary" icon="el-icon-search" size="mini" @click="handleSearch">搜索</el-button>
      </el-input>
      <div v-show="searchType === 'Radishes'" class="drawer-tips ft-gray">
        <div class="mb5">
          人选关键词搜索的几种格式： 1、姓名； 2、姓名+空格+公司； 3、姓名+空格+公司+空格+部门； 4、手机号；
        </div>
        <div v-if="list.length > 0">
          <el-button v-if="!selectionVisible" type="primary" size="mini" @click="selectRadishes"
            >选择合并人选</el-button
          >
          <el-button v-if="selectionVisible" type="primary" size="mini" @click="selectionVisible = false"
            >取消</el-button
          >
          <el-button
            v-if="selectionVisible"
            :disabled="Object.keys(selection).length < 2"
            type="primary"
            size="mini"
            @click="mergeConfirm"
            >确认合并</el-button
          >
        </div>
      </div>
      <el-table
        v-if="searchType === 'Radishes'"
        key="Radishes"
        v-loading="pending"
        :data="list"
        size="mini"
        max-height="400"
        style="width: 100%"
      >
        <el-table-column label="选择" width="55">
          <template slot-scope="scope">
            <div v-if="selectionVisible" @click="selectionChange(scope.row._id)">
              <a v-if="!selection[scope.row._id]">选择</a>
              <a v-else class="circle_check"> <i class="el-icon-circle-check"></i> </a>
            </div>
            <a v-else @click="linkRadish(scope.row)">选择</a>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <div>
              <span class="drawer-link" @click="showRadishDetail({ id: scope.row._id, title: scope.row['姓名'] })">
                {{ scope.row['姓名'] }}
              </span>
            </div>
            <div style="color:#aaa">{{ scope.row['手机'] }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="公司" label="公司" />
        <el-table-column prop="部门" label="部门" />
        <el-table-column prop="目前职位" label="目前职位" />
      </el-table>
      <el-table
        v-if="searchType === 'Companies'"
        key="Companies"
        v-loading="pending"
        :data="list"
        size="mini"
        max-height="400"
        style="width: 100%"
      >
        <el-table-column label="操作" width="55">
          <template slot-scope="scope">
            <a @click="linkCompany(scope.row)">选择</a>
          </template>
        </el-table-column>
        <el-table-column prop="公司名称" label="公司" />
        <el-table-column prop="简称" label="简称" />
        <el-table-column prop="公司类型" label="类型" />
        <el-table-column prop="签约" label="签约" />
      </el-table>
      <el-table
        v-if="searchType === 'Projects'"
        key="projects"
        v-loading="pending"
        :data="list"
        size="mini"
        max-height="400"
        style="width: 100%"
      >
        <el-table-column label="操作" width="55">
          <template slot-scope="scope">
            <a @click="linkProject(scope.row)">选择</a>
          </template>
        </el-table-column>
        <el-table-column prop="客户公司" label="公司" />
        <el-table-column prop="部门" label="部门" />
        <el-table-column prop="项目名称" label="项目" />
        <el-table-column prop="职能模块" label="职能模块" />
        <el-table-column prop="项目状态" label="状态" />
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="danger" @click="$emit('update:visible', false)">关 闭</el-button>
    </span>
    <MergeRadishes :visible.sync="mergeVisible" :radishes="selectedRadishes" :merge-success="mergeSuccess" />
  </el-dialog>
</template>

<script>
import MergeRadishes from './MergeRadishes.vue'
// import { fileTypes } from '../constant/type'
import { projectFileTypes } from '../constant/type'
import * as fixedvariant from '../../../company/statistics/variant/fixedvariant'
import { arrRemove } from '../constant/utils'

const companyFileTypes = fixedvariant.公司附件类型
const radishFileTypes = ['原始简历', '推荐报告', '背景调查', '薪资证明', '测评报告', '会面记录', '名片', '其他资料']
export default {
  components: { MergeRadishes },
  props: {
    typeSelectorHidden: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    linkTarget: { type: Object, default: () => ({}) },
    searchKeywords: { type: String, default: '' },
    selectRow: { type: Function, default: undefined },
  },
  data() {
    return {
      list: [],
      keywords: '',
      searchType: 'Radishes',
      pending: false,
      fileType: '',
      selectionVisible: false,
      selection: {},
      mergeVisible: false,
      selectedRadishes: [],
      fileTypes: {
        Radishes: radishFileTypes,
        Companies: companyFileTypes,
        Projects: projectFileTypes,
      },
    }
  },
  // computed: {
  //   fileTypes() {
  //     return fileTypes
  //   },
  // },
  watch: {
    searchType(value, oldValue) {
      if (value === oldValue) return
      this.fileType = ''
      this.list = []
      this.handleSearch()
    },
    searchKeywords(value, oldValue) {
      if (value === oldValue) return
      this.keywords = value
    },
  },
  methods: {
    async handleSearch() {
      const { searchType, keywords } = this
      this.pending = true
      await this[`search${searchType}`](keywords)
      this.pending = false
    },
    async linkRadish(radish) {
      if (!this.fileType) return this.$message.info('请选择文件类型')
      if (this.selectRow) return this.selectRow(radish, this.searchType)
      const id = radish._id
      const { fileType, linkTarget } = this
      try {
        await app.service('project').upsertAttachmentFromOss(
          Object.assign(linkTarget, {
            id,
            idField: 'rid',
            fileType,
          }),
        )
        this.$emit('onLink', {
          id,
          fileType,
          idField: 'rid',
          link: `${radish['姓名']}${radish['公司'] ? `-${radish['公司']}` : ''}${
            radish['部门'] ? `-${radish['部门']}` : ''
          }`,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async linkCompany(company) {
      if (!this.fileType) return this.$message.info('请选择文件类型')
      if (this.selectRow) return this.selectRow(company, this.searchType)
      const id = company._id
      const { fileType, linkTarget } = this
      try {
        await app.service('project').upsertAttachmentFromOss(
          Object.assign(linkTarget, {
            id,
            idField: 'companyId',
            fileType,
          }),
        )
        this.$emit('onLink', {
          id,
          fileType,
          idField: 'companyId',
          link: `${company['简称'] || company['公司名称']}`,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async linkProject(project) {
      if (!this.fileType) return this.$message.info('请选择文件类型')
      if (this.selectRow) return this.selectRow(project, this.searchType)
      const id = project._id
      const { fileType, linkTarget } = this
      try {
        await app.service('project').upsertAttachmentFromOss(
          Object.assign(linkTarget, {
            id,
            idField: 'projectId',
            fileType,
          }),
        )
        this.$emit('onLink', {
          id,
          fileType,
          idField: 'projectId',
          link: `${project['客户公司']}${project['部门'] ? `-${project['部门']}` : ''}-${project['项目名称']}`,
        })
        this.$emit('update:visible', false)
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async searchRadishes(keywords) {
      try {
        const { data } = await app.service('misc').searchEs({
          keywords,
          type: '人选',
          fields: ['姓名', '拼音', '公司', '部门', '职能模块', '手机'],
          and: true,
        })
        this.list = data || []
      } catch (e) {
        console.error(e)
      }
    },
    async searchCompanies(keywords) {
      try {
        const { data } = await app.service('company').serchCompany(keywords)
        this.list = data || []
      } catch (e) {
        console.error(e)
      }
    },
    async searchProjects(keywords) {
      try {
        const { data } = await app.service('project').search({
          keywords,
          type: '项目',
        })
        this.list = data || []
      } catch (e) {
        console.error(e)
      }
    },
    selectRadishes() {
      this.selection = {}
      this.selectedRadishes = []
      this.selectionVisible = true
    },
    selectionChange(id) {
      if (this.selection[id]) {
        delete this.selection[id]
        this.selection = Object.assign({}, this.selection)
      } else {
        this.selection = Object.assign({}, this.selection, { [id]: true })
      }
    },
    mergeConfirm() {
      this.selectedRadishes = this.list.filter(radish => this.selection[radish._id])
      this.mergeVisible = true
    },
    mergeSuccess(first, second) {
      if (!Array.isArray(second)) return
      arrRemove(this.list, radish => second.includes(radish._id))
      this.mergeVisible = false
    },
    showRadishDetail({ id, title }) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
  },
}
</script>
<style>
.circle_check {
  display: inline-block;
  font-size: 18px;
  color: #42b983;
}
</style>
